export const PROFILE_CARD_HOVER_DELAY = { delay: { open: 300, close: 0 } };
